angular
    .module('WizApp')
    .component('googleConnect', {
        controller: [
            '$scope',
            'SyncService',
            'EVENT_NAMES',
            'CookiesConsentService',
            function ($scope, SyncService, EVENT_NAMES, CookiesConsentService) {
                const vm = this;

                vm.isLoading = false;
                vm.googleConsent = true;

                vm.open = SyncService.getOpener('signup', 'google');

                vm.showCookieActivator = showCookieActivator;
                vm.getConsent = getConsent;
                vm.handleClick = handleClick;

                SyncService
                    .on('google', 'signup')
                    .start(() => {
                        vm.isLoading = true;
                        $scope.$emit(EVENT_NAMES.googleConnect.start);
                    })
                    .success(() => {
                        $scope.$emit(EVENT_NAMES.googleConnect.success);
                    })
                    .error(() => {
                        $scope.$emit(EVENT_NAMES.googleConnect.error);
                    })
                    .always(() => {
                        vm.isLoading = false;
                    })
                ;

                function showCookieActivator () {
                    $scope.$emit(EVENT_NAMES.googleConnect.cookieActivator);
                }

                function getConsent() {
                    return CookiesConsentService.getCookiesConsent();
                }

                function handleClick() {
                    vm.getConsent().then(data => {
                        return data.connect_google ? vm.open() : vm.showCookieActivator();
                    });
                }
            },
        ],
        // language=HTML
        template:
        `
            <div>
                <button
                    type="button"
                    class="button button--block button--google"
                    data-ng-click="$ctrl.handleClick()"
                    data-ng-disabled="$ctrl.isLoading"
                >
                    <img
                        src="/bundles/wizbiicore/images/v35/logo-bt-google.svg"
                        alt=""
                        height="18"
                        width="18"
                        class="v-align-text-top margin-right-inner"
                    />
                    {[:: 'wizbii.registerlayer.messages.form.googlelogin' | trans ]}
                </button>
            </div>
        `,
    });
